export default __webpack_public_path__ + "static/media/ericRosen.eecbec34.webp";